"use client";

import {
  popSignUp,
  SignUpElement,
  SignUpType,
} from "@faire/deprecated-retailer-visitor-shared/lib/popSignUp";
import { trackSignupOpenBrandpageMainCtaClick } from "@faire/web-api--source/events/signup/click/openBrandpageMainCta";
import { getCurrentPath } from "@faire/web/common/Path";
import { useIsSSR } from "@faire/web/common/server-side-rendering/isSSR";
import { Button, ButtonProps } from "@faire/web/slate-deprecated/Button";
import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

type Props = ButtonProps & {
  brandToken: string | undefined;
  element: SignUpElement;
  sourceId: string;
  children?: React.ReactNode;
  isTertiary?: boolean;
};

export const SignUpButton: React.FC<Props> = (props) => {
  const { brandToken, element, sourceId, children, isTertiary, ...rest } =
    props;
  const isSSR = useIsSSR();
  const history = useHistory();

  const handleSignUp = (
    e: React.MouseEvent<HTMLButtonElement> | React.MouseEvent<HTMLAnchorElement>
  ) => {
    e.preventDefault();
    popSignUp(
      history,
      SignUpType.BRAND,
      trackSignupOpenBrandpageMainCtaClick,
      {
        element,
        sourceId,
      },
      {
        brand: brandToken,
      }
    );
  };

  return (
    <StyledButton
      variant={isTertiary ? "tertiary" : "primary"}
      onClick={handleSignUp}
      data-test-id="brand-sign-up-button"
      // We set a link for graceful degredation in SSR.
      linkTo={
        isSSR
          ? getCurrentPath()
              .replace({
                signUp: "brand",
                brand: brandToken,
              })
              .toString()
          : undefined
      }
      {...rest}
    >
      {children}
    </StyledButton>
  );
};

const StyledButton = styled(Button)`
  width: fit-content;
`;
